/**
* Endpoint methods related to the Webshop Payment
*/
import API from "./Api";

export default {

    async create(body) {
        return API.post("/temporarywebshoporder/create", body, "MOODLE_SESSION_JSON");
    },

};